import React, { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const PrivateUserRoutes = () => {
    const { userDetails } = useContext(AuthContext)

    return (
        userDetails ? ((userDetails.user_type === "D" || userDetails.user_type === "M" || userDetails.user_type === "F") ? <Outlet /> : <Navigate to='/appointment' />) : <Navigate to='/sign-in' />
    )
};

export default PrivateUserRoutes;
